// UI visibility only. The existing API handlers remain available for future use.
export const personalSettingsFeaturesV108 = Object.freeze({
  inviteLink: false,
  selfAccountDeletion: false,
});
